var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "btn-area"
  }, [_c('button', {
    on: {
      "click": _vm.openModal
    }
  }, [_vm._m(0)]), _vm._v(" "), _c('banner')], 1), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "toriyasaiQuiz",
      "minWidth": 300,
      "width": 852,
      "height": 655,
      "adaptive": true
    },
    on: {
      "before-close": _vm.quizReset
    }
  }, [(_vm.state === 'start') ? _c('section', [_c('div', {
    staticClass: "start-content"
  }, [_c('header', [_c('h2', [_c('img', {
    attrs: {
      "src": require("../assets/images/logo.svg"),
      "alt": "株式会社まつや"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "txt-start"
  }, [_vm._v("とり野菜みその素朴なギモン！"), _c('br'), _vm._v("全部で5問の"), _c('img', {
    attrs: {
      "src": require("../assets/images/btn_yes.svg"),
      "alt": "◯"
    }
  }), _c('img', {
    attrs: {
      "src": require("../assets/images/btn_no.svg"),
      "alt": "×"
    }
  }), _vm._v("クイズに"), _c('br', {
    staticClass: "hidden-sm"
  }), _vm._v("挑戦すると"), _c('br', {
    staticClass: "visible-sm"
  }), _vm._v("あなたの"), _c('br', {
    staticClass: "hidden-sm"
  }), _vm._v("みそ鍋革命度数がわかる！")]), _vm._v(" "), _c('div', {
    staticClass: "btn-start"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.state = 'q1'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/btn_start.svg"),
      "alt": "START"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "btn-close"
  }, [_c('button', {
    on: {
      "click": _vm.closeModal
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/btn_close.svg"),
      "alt": ""
    }
  })])])])]) : (_vm.state === 'q1') ? _c('section', {
    staticClass: "question"
  }, [_c('div', {
    staticClass: "quiz-content"
  }, [_c('header', [_c('p', [_c('img', {
    attrs: {
      "src": require("../assets/images/txt_q1.svg"),
      "alt": "Q1"
    }
  })]), _vm._v(" "), _c('h2', [_vm._v("とり野菜みその「とり」は"), _c('br'), _vm._v("鶏肉の「とり」である。")])]), _vm._v(" "), _c('div', {
    staticClass: "illust-q1"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/img_q1.svg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('ul', [_c('li', [_c('button', {
    on: {
      "click": function($event) {
        _vm.state = 'q1-result'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/btn_yes.svg"),
      "alt": "◯"
    }
  })])]), _vm._v(" "), _c('li', [_c('button', {
    on: {
      "click": function($event) {
        _vm.resultCount += 20, _vm.resultRight = true, _vm.state = 'q1-result'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/btn_no.svg"),
      "alt": "×"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "btn-close"
  }, [_c('button', {
    on: {
      "click": _vm.closeModal
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/btn_close.svg"),
      "alt": ""
    }
  })])])])]) : (_vm.state === 'q1-result') ? _c('section', {
    staticClass: "result"
  }, [_c('div', {
    staticClass: "quiz-result",
    class: {
      'result-right': _vm.resultRight
    }
  }, [_c('header', [_c('p', [_c('img', {
    attrs: {
      "src": require("../assets/images/txt_q1.svg"),
      "alt": "Q1"
    }
  })]), _vm._v(" "), (_vm.resultRight) ? _c('h2', [_c('img', {
    attrs: {
      "src": require("../assets/images/hd_result_right.svg"),
      "alt": "ピンポーンッ"
    }
  })]) : _c('h2', [_c('img', {
    attrs: {
      "src": require("../assets/images/hd_result_wrong.svg"),
      "alt": "ハズレーッ"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "txt-catch"
  }, [_vm._v("とり野菜みその「とり」は"), _c('br'), _vm._v("野菜や栄養を「摂る」の「とり」。")]), _vm._v(" "), _c('p', {
    staticClass: "txt-normal"
  }, [_vm._v("「とり野菜みそ」は、江戸時代に廻船問屋を営んでいたまつや初代当主が船員たちの体調を考え、考案した味噌がルーツ。厳しい航海を乗り切るために不足しがちな野菜や栄養もたっぷり摂れ、船員たちに大変喜ばれていました。摂る「野菜味噌」→摂り「野菜味噌」→「とり野菜みそ」ということで、商品名の「とり」は鶏肉からではなく、野菜や栄養を摂るという意味からきています。")]), _vm._v(" "), _c('div', {
    staticClass: "btn-next"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.state = 'q2', _vm.resultRight = false
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/btn_quiz_next.svg"),
      "alt": "次へ"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "btn-close"
  }, [_c('button', {
    on: {
      "click": _vm.closeModal
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/btn_close.svg"),
      "alt": ""
    }
  })])])])]) : (_vm.state === 'q2') ? _c('section', {
    staticClass: "question"
  }, [_c('div', {
    staticClass: "quiz-content"
  }, [_c('header', [_c('p', [_c('img', {
    attrs: {
      "src": require("../assets/images/txt_q2.svg"),
      "alt": "Q2"
    }
  })]), _vm._v(" "), _c('h2', [_vm._v("みそを入れるタイミングは"), _c('br'), _vm._v("水だけの状態の時に入れる。")])]), _vm._v(" "), _c('div', {
    staticClass: "illust-q2"
  }, [_c('img', {
    attrs: {
      "srcset": "static/assets/images/img_q2.png, static/assets/images/img_q2@2x.png 2x",
      "src": "static/assets/images/img_q2.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('ul', [_c('li', [_c('button', {
    on: {
      "click": function($event) {
        _vm.resultCount += 20, _vm.resultRight = true, _vm.state = 'q2-result'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/btn_yes.svg"),
      "alt": "◯"
    }
  })])]), _vm._v(" "), _c('li', [_c('button', {
    on: {
      "click": function($event) {
        _vm.state = 'q2-result'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/btn_no.svg"),
      "alt": "×"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "btn-close"
  }, [_c('button', {
    on: {
      "click": _vm.closeModal
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/btn_close.svg"),
      "alt": ""
    }
  })])])])]) : (_vm.state === 'q2-result') ? _c('section', {
    staticClass: "result"
  }, [_c('div', {
    staticClass: "quiz-result",
    class: {
      'result-right': _vm.resultRight
    }
  }, [_c('header', [_c('p', [_c('img', {
    attrs: {
      "src": require("../assets/images/txt_q2.svg"),
      "alt": "Q2"
    }
  })]), _vm._v(" "), (_vm.resultRight) ? _c('h2', [_c('img', {
    attrs: {
      "src": require("../assets/images/hd_result_right.svg"),
      "alt": "ピンポーンッ"
    }
  })]) : _c('h2', [_c('img', {
    attrs: {
      "src": require("../assets/images/hd_result_wrong.svg"),
      "alt": "ハズレーッ"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "txt-catch"
  }, [_vm._v("とり野菜みそって"), _c('br'), _vm._v("調理がとってもカンタン！")]), _vm._v(" "), _c('p', {
    staticClass: "txt-normal"
  }, [_vm._v("一見、調理の手間がかかりそうに見えるとり野菜みそ。いえいえ、実はとーってもカンタンなんです。"), _c('br'), _vm._v("まずは、お鍋に水をいれて、次にとり野菜みそを投入。かき混ぜて溶かしたら、具材を入れて火にかければ、"), _c('br'), _vm._v("ハイッ！完成〜！！")]), _vm._v(" "), _c('div', {
    staticClass: "btn-next"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.state = 'q3', _vm.resultRight = false
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/btn_quiz_next.svg"),
      "alt": "次へ"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "btn-close"
  }, [_c('button', {
    on: {
      "click": _vm.closeModal
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/btn_close.svg"),
      "alt": ""
    }
  })])])])]) : (_vm.state === 'q3') ? _c('section', {
    staticClass: "question"
  }, [_c('div', {
    staticClass: "quiz-content"
  }, [_c('header', [_c('p', [_c('img', {
    attrs: {
      "src": require("../assets/images/txt_q3.svg"),
      "alt": "Q3"
    }
  })]), _vm._v(" "), _c('h2', [_vm._v("とり野菜みそは"), _c('br'), _vm._v("一人鍋もできる。")])]), _vm._v(" "), _c('div', {
    staticClass: "illust-q3"
  }, [_c('img', {
    attrs: {
      "srcset": "static/assets/images/img_q3.png, static/assets/images/img_q3@2x.png 2x",
      "src": "static/assets/images/img_q3.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('ul', [_c('li', [_c('button', {
    on: {
      "click": function($event) {
        _vm.resultCount += 20, _vm.resultRight = true, _vm.state = 'q3-result'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/btn_yes.svg"),
      "alt": "◯"
    }
  })])]), _vm._v(" "), _c('li', [_c('button', {
    on: {
      "click": function($event) {
        _vm.state = 'q3-result'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/btn_no.svg"),
      "alt": "×"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "btn-close"
  }, [_c('button', {
    on: {
      "click": _vm.closeModal
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/btn_close.svg"),
      "alt": ""
    }
  })])])])]) : (_vm.state === 'q3-result') ? _c('section', {
    staticClass: "result"
  }, [_c('div', {
    staticClass: "quiz-result",
    class: {
      'result-right': _vm.resultRight
    }
  }, [_c('header', [_c('p', [_c('img', {
    attrs: {
      "src": require("../assets/images/txt_q3.svg"),
      "alt": "Q3"
    }
  })]), _vm._v(" "), (_vm.resultRight) ? _c('h2', [_c('img', {
    attrs: {
      "src": require("../assets/images/hd_result_right.svg"),
      "alt": "ピンポーンッ"
    }
  })]) : _c('h2', [_c('img', {
    attrs: {
      "src": require("../assets/images/hd_result_wrong.svg"),
      "alt": "ハズレーッ"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "illust-q3-result"
  }, [_c('img', {
    attrs: {
      "srcset": "static/assets/images/img_q3_result.png, static/assets/images/img_q3_result@2x.png 2x",
      "src": "static/assets/images/img_q3_result.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "txt-catch"
  }, [_vm._v("スパウトタイプがあるから"), _c('br'), _vm._v("小分けに使用できる！")]), _vm._v(" "), _c('p', {
    staticClass: "txt-normal"
  }, [_vm._v("キャップ付だから、使い切らなくても保存がラク。少しずつ使えば、なんと一人鍋が10回※もできます！鍋だけじゃなく料理の調味料としてもいろんな使い道があるんです。"), _c('br'), _c('span', {
    staticClass: "note"
  }, [_vm._v("※500gサイズのスパウトパックでの量です。。")])]), _vm._v(" "), _c('div', {
    staticClass: "btn-next"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.state = 'q4', _vm.resultRight = false
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/btn_quiz_next.svg"),
      "alt": "次へ"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "btn-close"
  }, [_c('button', {
    on: {
      "click": _vm.closeModal
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/btn_close.svg"),
      "alt": ""
    }
  })])])])]) : (_vm.state === 'q4') ? _c('section', {
    staticClass: "question"
  }, [_c('div', {
    staticClass: "quiz-content"
  }, [_c('header', [_c('p', [_c('img', {
    attrs: {
      "src": require("../assets/images/txt_q4.svg"),
      "alt": "Q4"
    }
  })]), _vm._v(" "), _c('h2', [_vm._v("とり野菜みそは"), _c('br'), _vm._v("塩分が高めである。")])]), _vm._v(" "), _c('div', {
    staticClass: "illust-q4"
  }, [_c('img', {
    attrs: {
      "srcset": "static/assets/images/img_q4.png, static/assets/images/img_q4@2x.png 2x",
      "src": "static/assets/images/img_q4.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('ul', [_c('li', [_c('button', {
    on: {
      "click": function($event) {
        _vm.state = 'q4-result'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/btn_yes.svg"),
      "alt": "◯"
    }
  })])]), _vm._v(" "), _c('li', [_c('button', {
    on: {
      "click": function($event) {
        _vm.resultCount += 20, _vm.resultRight = true, _vm.state = 'q4-result'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/btn_no.svg"),
      "alt": "×"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "btn-close"
  }, [_c('button', {
    on: {
      "click": _vm.closeModal
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/btn_close.svg"),
      "alt": ""
    }
  })])])])]) : (_vm.state === 'q4-result') ? _c('section', {
    staticClass: "result"
  }, [_c('div', {
    staticClass: "quiz-result",
    class: {
      'result-right': _vm.resultRight
    }
  }, [_c('header', [_c('p', [_c('img', {
    attrs: {
      "src": require("../assets/images/txt_q4.svg"),
      "alt": "Q4"
    }
  })]), _vm._v(" "), (_vm.resultRight) ? _c('h2', [_c('img', {
    attrs: {
      "src": require("../assets/images/hd_result_right.svg"),
      "alt": "ピンポーンッ"
    }
  })]) : _c('h2', [_c('img', {
    attrs: {
      "src": require("../assets/images/hd_result_wrong.svg"),
      "alt": "ハズレーッ"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "txt-catch"
  }, [_vm._v("野菜をたくさん入れるから"), _c('br'), _vm._v("ちょうどいい味に仕上がる。")]), _vm._v(" "), _c('p', {
    staticClass: "txt-normal"
  }, [_vm._v("500ccのお水に対して200gの袋を全部入れます。こんなに入れて塩辛くないの？と思うかもしれませんが、水分を含んだ白菜をたくさん入れるので、ちょうどいい塩梅の味に仕上がります。")]), _vm._v(" "), _c('div', {
    staticClass: "btn-next"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.state = 'q5', _vm.resultRight = false
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/btn_quiz_next.svg"),
      "alt": "次へ"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "btn-close"
  }, [_c('button', {
    on: {
      "click": _vm.closeModal
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/btn_close.svg"),
      "alt": ""
    }
  })])])])]) : (_vm.state === 'q5') ? _c('section', {
    staticClass: "question"
  }, [_c('div', {
    staticClass: "quiz-content"
  }, [_c('header', [_c('p', [_c('img', {
    attrs: {
      "src": require("../assets/images/txt_q5.svg"),
      "alt": "Q5"
    }
  })]), _vm._v(" "), _c('h2', [_vm._v("とり野菜みそって"), _c('br'), _vm._v("他の鍋の素と比べたら"), _c('br'), _vm._v("ちょっとお高め。")])]), _vm._v(" "), _c('div', {
    staticClass: "illust-q5"
  }, [_c('img', {
    attrs: {
      "srcset": "static/assets/images/img_miso.png, static/assets/images/img_miso@2x.png 2x",
      "src": "static/assets/images/img_miso.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('ul', [_c('li', [_c('button', {
    on: {
      "click": function($event) {
        _vm.state = 'q5-result'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/btn_yes.svg"),
      "alt": "◯"
    }
  })])]), _vm._v(" "), _c('li', [_c('button', {
    on: {
      "click": function($event) {
        _vm.resultCount += 20, _vm.resultRight = true, _vm.state = 'q5-result'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/btn_no.svg"),
      "alt": "×"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "btn-close"
  }, [_c('button', {
    on: {
      "click": _vm.closeModal
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/btn_close.svg"),
      "alt": ""
    }
  })])])])]) : (_vm.state === 'q5-result') ? _c('section', {
    staticClass: "result"
  }, [_c('div', {
    staticClass: "quiz-result",
    class: {
      'result-right': _vm.resultRight
    }
  }, [_c('header', [_c('p', [_c('img', {
    attrs: {
      "src": require("../assets/images/txt_q5.svg"),
      "alt": "Q5"
    }
  })]), _vm._v(" "), (_vm.resultRight) ? _c('h2', [_c('img', {
    attrs: {
      "src": require("../assets/images/hd_result_right.svg"),
      "alt": "ピンポーンッ"
    }
  })]) : _c('h2', [_c('img', {
    attrs: {
      "src": require("../assets/images/hd_result_wrong.svg"),
      "alt": "ハズレーッ"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "txt-catch"
  }, [_vm._v("この小さなサイズで"), _c('br'), _vm._v("3〜4人前も作れるんです！")]), _vm._v(" "), _c('div', {
    staticClass: "figure-wrap"
  }, [_c('figure', [_c('img', {
    attrs: {
      "srcset": "static/assets/images/img_miso.png, static/assets/images/img_miso@2x.png 2x",
      "src": "static/assets/images/img_miso.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('figcaption', [_vm._v("※200gサイズ")])]), _vm._v(" "), _c('p', {
    staticClass: "txt-normal"
  }, [_vm._v("他社製品と比べると、半分くらいのサイズで金額は同じくらい。ちょっと割高だな〜って感じる方もいるのでは？いえいえ、この小さなサイズでしっかり3〜4人前の立派なとり野菜みそ鍋ができるんです！")])]), _vm._v(" "), _c('div', {
    staticClass: "btn-finish"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.state = 'finish'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/btn_quiz_result.svg"),
      "alt": "結果発表"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "btn-close"
  }, [_c('button', {
    on: {
      "click": _vm.closeModal
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/btn_close.svg"),
      "alt": ""
    }
  })])])])]) : (_vm.state === 'finish' && _vm.resultCount === 100) ? _c('div', {
    staticClass: "finish-wrap"
  }, [_c('div', {
    staticClass: "finish result-100"
  }, [_c('a', {
    staticClass: "recipie-link",
    attrs: {
      "href": "http://www.toriyasaimiso.jp/recipe",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/btn_result_recipie.svg"),
      "alt": "とり野菜みそレシピへ"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "download-link"
  }, [_c('button', {
    on: {
      "click": _vm.wallPaperModal
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/btn_download.svg"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "btn-close"
  }, [_c('button', {
    on: {
      "click": _vm.closeModal
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/btn_close.svg"),
      "alt": ""
    }
  })])])])]) : (_vm.state === 'finish' && _vm.resultCount === 80) ? _c('div', {
    staticClass: "finish-wrap"
  }, [_c('div', {
    staticClass: "finish result-80"
  }, [_c('a', {
    staticClass: "recipie-link",
    attrs: {
      "href": "http://www.toriyasaimiso.jp/recipe",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/btn_result_recipie.svg"),
      "alt": "とり野菜みそレシピへ"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "btn-close"
  }, [_c('button', {
    on: {
      "click": _vm.closeModal
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/btn_close.svg"),
      "alt": ""
    }
  })])])])]) : (_vm.state === 'finish' && _vm.resultCount === 60) ? _c('div', {
    staticClass: "finish-wrap"
  }, [_c('div', {
    staticClass: "finish result-60"
  }, [_c('a', {
    staticClass: "recipie-link",
    attrs: {
      "href": "http://www.toriyasaimiso.jp/recipe",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/btn_result_recipie.svg"),
      "alt": "とり野菜みそレシピへ"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "btn-close"
  }, [_c('button', {
    on: {
      "click": _vm.closeModal
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/btn_close.svg"),
      "alt": ""
    }
  })])])])]) : (_vm.state === 'finish' && _vm.resultCount === 40) ? _c('div', {
    staticClass: "finish-wrap"
  }, [_c('div', {
    staticClass: "finish result-40"
  }, [_c('a', {
    staticClass: "recipie-link",
    attrs: {
      "href": "http://www.toriyasaimiso.jp/recipe",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/btn_result_recipie.svg"),
      "alt": "とり野菜みそレシピへ"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "btn-close"
  }, [_c('button', {
    on: {
      "click": _vm.closeModal
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/btn_close.svg"),
      "alt": ""
    }
  })])])])]) : (_vm.state === 'finish' && _vm.resultCount === 20) ? _c('div', {
    staticClass: "finish-wrap"
  }, [_c('div', {
    staticClass: "finish result-20"
  }, [_c('a', {
    staticClass: "recipie-link",
    attrs: {
      "href": "http://www.toriyasaimiso.jp/recipe",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/btn_result_recipie.svg"),
      "alt": "とり野菜みそレシピへ"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "btn-close"
  }, [_c('button', {
    on: {
      "click": _vm.closeModal
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/btn_close.svg"),
      "alt": ""
    }
  })])])])]) : (_vm.state === 'finish' && _vm.resultCount === 0) ? _c('div', {
    staticClass: "finish-wrap"
  }, [_c('div', {
    staticClass: "finish result-00"
  }, [_c('a', {
    staticClass: "recipie-link",
    attrs: {
      "href": "http://www.toriyasaimiso.jp/recipe",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/btn_result_recipie.svg"),
      "alt": "とり野菜みそレシピへ"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "btn-close"
  }, [_c('button', {
    on: {
      "click": _vm.closeModal
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/btn_close.svg"),
      "alt": ""
    }
  })])])])]) : _vm._e()]), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "wallPaper",
      "minWidth": 300,
      "width": 900,
      "height": 700,
      "adaptive": true
    }
  }, [_c('div', {
    staticClass: "wallpaper-wrap"
  }, [_c('div', {
    staticClass: "wallpaper-inner"
  }, [_c('wallpaper'), _vm._v(" "), _c('div', {
    staticClass: "btn-close-wallpaper"
  }, [_c('button', {
    on: {
      "click": _vm.closeWallPaperModal
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/btn_close.svg"),
      "alt": ""
    }
  })])])], 1)])])], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('picture', [_c('source', {
    attrs: {
      "media": "(min-width: 768px)",
      "srcset": "static/assets/images/btn_quiz_pc.png 1x, static/assets/images/btn_quiz_pc@2x.png 2x"
    }
  }), _vm._v(" "), _c('source', {
    attrs: {
      "media": "(min-width: 320px)",
      "srcset": "static/assets/images/btn_quiz_sp.png 1x, static/assets/images/btn_quiz_sp@2x.png 2x"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "static/assets/images/btn_quiz_pc.png",
      "alt": "トリさんが出題する！とり野菜みそQ&Aクイズ。全問正解で「東村アキコ先生書き下ろし限定壁紙」をプレゼント！"
    }
  })])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-372c9c97","hasScoped":true,"transformToRequire":{"video":"src","source":"srcset","img":["src","srcset"],"image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Quiz.vue
// module id = 86
// module chunks = 0